import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import Form from '../Form';
import { getSchemaDefaultValues, parseSchema, getValidationsFromSchema } from './utils';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';

const SchemaForm = ({ component, schema, uiSchema, onSubmit, onCancel, renderActions, values }) => {
  const fields = parseSchema(schema, uiSchema);
  const schemaDefaultValues = getSchemaDefaultValues(fields);
  const defaultValues = { ...schemaDefaultValues, ...values };
  const form = useForm({
    validationSchema: getValidationsFromSchema(schema),
    defaultValues,
    onSubmit,
    onCancel,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form component={component} form={form} clearOnUnmount={false} renderActions={renderActions}>
        {fields.map(({ name, InputComponent, inputProps }) => (
          <InputComponent key={`schema_field_${name}`} {...inputProps} />
        ))}
      </Form>
    </LoadingWrapper>
  );
};

SchemaForm.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  renderActions: PropTypes.bool,
  values: PropTypes.object,
};

SchemaForm.defaultProps = {
  component: undefined,
  uiSchema: {},
  onSubmit: undefined,
  onCancel: undefined,
  renderActions: true,
  values: {},
};

export default SchemaForm;
